import { User } from "./../../_models/User";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "src/app/_services/authentication.service";
import { distinctUntilChanged, take } from "rxjs/operators";

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
})
export class NavigationComponent implements OnInit {
  user: User;
  firstname: string = "";
  lastname: string = "";
  countryName: string = "";
  public userRole: string;
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit() {
    this.authService.currentUser$
      .pipe(distinctUntilChanged())
      .subscribe((user) => {
        if (user) {
          this.user = user;
          this.firstname = user.username;
          if (user.is_super_admin) {
            this.userRole = "Super Admin";
          } else {
            this.userRole = user.role;
          }
          this.countryName = user.country;
          this.countryName = (user.country || "").toLowerCase();
        }
      });
      this.authService.getProfile().pipe(take(1)).subscribe();
  }

  logOut() {
    this.authService.logout();
  }

  routeDashboard() {
    if (this.countryName === "uganda") {
      this.router.navigateByUrl("/mobile-dashboard");
    } else {
      this.router.navigateByUrl("/india-dashboard");
    }
  }

  public get isSuperAdmin$() {
    return this.authService.isSuperAdmin$();
  }
}
